import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[data-cy]',
})
export class AutomationAttributeDirective {
  constructor(private renderer: Renderer2, private elRef: ElementRef) {
    if (environment.production) {
      this.renderer.removeAttribute(this.elRef.nativeElement, 'data-cy');
    }
  }
}
